/* Aylesva home (hm-*) — carousels, tabs and add-to-cart. Loaded by every hm section; runs once. */
(function () {
  if (window.__hmHome) return;
  window.__hmHome = true;

  function initCarousel(car) {
    if (car.__hm) return; car.__hm = true;
    var track = car.querySelector('.hm-car-track');
    var prev = car.querySelector('.hm-car-arrow[data-dir="-1"]');
    var next = car.querySelector('.hm-car-arrow[data-dir="1"]');
    var dots = car.parentNode.querySelector('.hm-dots[data-for="' + car.id + '"]');
    if (!track) return;
    function step() {
      var item = track.firstElementChild;
      return item ? item.offsetWidth + parseFloat(getComputedStyle(track).columnGap || 16) : track.clientWidth;
    }
    function pages() { return Math.max(1, Math.ceil((track.scrollWidth - 2) / track.clientWidth)); }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      if (dots) {
        var n = pages(), cur = max <= 0 ? 0 : Math.round(track.scrollLeft / max * (n - 1));
        if (dots.children.length !== n) {
          dots.innerHTML = '';
          for (var i = 0; i < n; i++) {
            var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Página ' + (i + 1));
            (function (i) { b.addEventListener('click', function () { track.scrollTo({ left: i / Math.max(1, n - 1) * max, behavior: 'smooth' }); }); })(i);
            dots.appendChild(b);
          }
        }
        dots.hidden = n < 2;
        Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === cur); });
      }
    }
    [prev, next].forEach(function (b) {
      if (b) b.addEventListener('click', function () { track.scrollBy({ left: step() * parseInt(b.dataset.dir, 10) * (b.dataset.page ? Math.max(1, Math.floor(track.clientWidth / step())) : 1), behavior: 'smooth' }); });
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    car.__hmUpdate = update;
    update();
    // Optional autoplay (promo banners); pauses while hovered or touched
    var auto = parseInt(car.dataset.autoplay || '0', 10);
    if (auto > 0) {
      var paused = false;
      car.addEventListener('mouseenter', function () { paused = true; });
      car.addEventListener('mouseleave', function () { paused = false; });
      track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      setInterval(function () {
        if (paused || document.hidden) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        if (max <= 0) return;
        if (track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' }); else track.scrollBy({ left: step(), behavior: 'smooth' });
      }, auto * 1000);
    }
  }

  function initTabs(root) {
    if (root.__hm) return; root.__hm = true;
    var tabs = root.querySelectorAll('[data-hm-tab]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on); });
        root.querySelectorAll('[data-hm-panel]').forEach(function (p) {
          var on = p.dataset.hmPanel === t.dataset.hmTab;
          p.hidden = !on;
          if (on) { var car = p.querySelector('.hm-car'); if (car) { if (car.__hmUpdate) car.__hmUpdate(); else initCarousel(car); } }
        });
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.hm-car').forEach(initCarousel);
    (scope || document).querySelectorAll('[data-hm-tabs]').forEach(initTabs);
  }

  /* ---------- Add to cart ---------- */
  function toast(msg, isError) {
    var el = document.querySelector('.hm-toast');
    if (!el) { el = document.createElement('div'); el.className = 'hm hm-toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.classList.toggle('is-error', !!isError);
    el.innerHTML = '';
    var s = document.createElement('span'); s.textContent = msg; el.appendChild(s);
    if (!isError) { var a = document.createElement('a'); a.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; a.textContent = 'View cart'; el.appendChild(a); }
    el.classList.add('is-show');
    clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('is-show'); }, 4000);
  }
  function updateCount(n) {
    document.querySelectorAll('#cart-products-count-text, .cart-products-count, .site-header__cart-count, [data-cart-count]').forEach(function (b) {
      b.textContent = n; b.classList.remove('ayl-hidden');
    });
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }
  function add(id, btn, card) {
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    btn.classList.add('is-busy'); btn.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        updateCount(cart.item_count);
        var main = card.querySelector('.hm-pcard-foot .hm-pcard-btn'), lbl = main.querySelector('span');
        var orig = main.dataset.label || lbl.textContent;
        main.dataset.label = orig;
        main.classList.add('is-done'); lbl.textContent = 'Added ✓';
        setTimeout(function () { main.classList.remove('is-done'); lbl.textContent = orig; }, 2500);
        toast('Added to cart!');
      })
      .catch(function (e) { toast((e && (e.description || e.message)) || 'Could not add it. Please try again.', true); })
      .finally(function () {
        btn.classList.remove('is-busy'); btn.disabled = false;
        var p = card.querySelector('.hm-pick'); if (p) p.hidden = true;
      });
  }
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.hm-pcard'); if (!card) return;
    var pick = card.querySelector('.hm-pick');
    if (e.target.closest('.hm-pick-close')) { pick.hidden = true; return; }
    var opt = e.target.closest('.hm-opt');
    if (opt) { add(opt.dataset.id, opt, card); return; }
    var btn = e.target.closest('.hm-pcard-foot .hm-pcard-btn');
    if (!btn || btn.disabled) return;
    if (btn.hasAttribute('data-pick')) {
      document.querySelectorAll('.hm-pick').forEach(function (p) { if (p !== pick) p.hidden = true; });
      pick.hidden = !pick.hidden;
    } else add(btn.dataset.id, btn, card);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
